export default function userAndClientIdConnector(store) {
  return {
    user: store.auth.user,
    clientID: store.appClient.clientID,
  };
}
